// Meta Pixel events from markup:
// <div data-metapixel='{"event":"ViewContent","value":1200,"currency":"EUR"}'></div>
// <div data-metapixel="ViewContent"></div>

// Params from the page's data-metapixel element, event name stripped off.
export function pixelParams()
{
	const raw = $('[data-metapixel]').attr('data-metapixel');
	if (!raw) return {};

	try
	{
		const { event, ...params } = JSON.parse(raw);
		return params;
	}
	catch (e)
	{
		return {};
	}
}

export function pixelTrack(event, params = {})
{
	if (typeof fbq !== 'function' || !event) return;

	// ponytail: always track(), not trackCustom() — switch if non-standard event names get used
	fbq('track', event, params);
}

$(function ()
{
	$('[data-metapixel]').each((i, elem) =>
	{
		const raw = $(elem).attr('data-metapixel');
		let data;

		try
		{
			data = JSON.parse(raw);
		}
		catch (e)
		{
			data = { event: raw };
		}

		const { event, ...params } = data;
		pixelTrack(event, params);
	});
});
